const mapperRangeToForm = (range, mapperToOption, mapperHeadlightToSelect) => {
    const { id, title, order, headlight, target, multiplier } = range
    const headlightToSelect = mapperHeadlightToSelect(headlight)
    return {
        id,
        title,
        order,
        headlight: mapperToOption(headlightToSelect),
        target,
        multiplier,
    }
}

export { mapperRangeToForm }
